import { view } from '@yola/ws-sdk';
import getUniqueValues from 'src/js/modules/utils/get-unique-values';

const getParentColumnsElementIds = (columnElementIds = []) =>
  getUniqueValues(
    columnElementIds
      .map((elementId) => {
        const columnElement = view.accessors.getLiveElement(elementId);
        const columnsElement = columnElement?.closest('ws-columns');

        return columnsElement ? view.accessors.getLiveElementId(columnsElement) : null;
      })
      .filter(Boolean)
  );

export default getParentColumnsElementIds;
